export default "__VITE_ASSET__KfwQ3gvM__"